<base-inquiry-document-preview
  *ngIf="!!inquiryDocumentInfo || !!documentToUploadInfo; else addDocumentButton"
  [documentInfo]="inquiryDocumentInfo"
  [documentToUploadInfo]="documentToUploadInfo"
  [isExistingDocument]="isExistingDocument"
  [inquiryId]="inquiryId"
  (cleanDocumentToUpload)="cleanInquiryDocumentToUpload()"
></base-inquiry-document-preview>

<ng-template #addDocumentButton>
  <base-button
    color="dark"
    label="document.add"
    [size]="buttonSize.md"
    (btnClick)="openUploadInquiryDocumentModal()"
  ></base-button>
</ng-template>

<ng-template #inquiryDocumentModal>
  <base-document-upload-modal
    [documentUploadForm]="documentForm"
    [submitted]="isDocumentFormSubmitted"
    [fixedCategory]="true"
    [hideExpirationDateSelection]="true"
    documentNameInputPlaceholder="inquiry.documentNamePlaceholder"
  ></base-document-upload-modal>
</ng-template>
